//Layouts
import LayoutAdmin from "../layouts/LayoutAdmin";
//ADMINpages
import AdminHome from "../pages/Admin"; // es una exportacion especial y
// da igual el nombre que se asigne porque este Admin.js es usado por el index.js
import AdminSingIn from "../pages/Admin/SignIn";
import AdminUsers from "../pages/Admin/Users";
import AdminMenuWeb from "../pages/Admin/MenuWeb";
import AdminCourses from "../pages/Admin/Courses";
import AdminBlog from "../pages/Admin/Blog";
//////////////////////////////////USUARIOS NORMALES////////////////
import LayoutBasic from "../layouts/LayoutBasic";
import Home from "../pages/Home"; //pagina home
import Contact from "../pages/Contact"; //pagina contact
import Courses from "../pages/Courses";
import Blog from "../pages/Blog";
//////////////////////////////////////////////////
//pagina de error
import Error404 from "../pages/Error404";
const routes = [
  {
    path: "/admin",
    component: LayoutAdmin,
    exact: false, //sirve para cargar el layout tanto en "/admin" como en "/admin/contact"
    routes: [
      {
        path: "/admin",
        component: AdminHome,
        exact: true, //significa que nos cargara dentro de "layoutAdmin" tambien "AdminHome"
      },
      {
        path: "/admin/login",
        component: AdminSingIn,
        exact: true, //cuando la ruta sea ""/admin/login" pero no la ruta anterior
      },
      {
        path: "/admin/users",
        component: AdminUsers,
        exact: true,
      },
      {
        path: "/admin/menu",
        component: AdminMenuWeb,
        exact: true,
      },
      {
        path: "/admin/courses",
        component: AdminCourses,
        exact: true,
      },
      {
        path: "/admin/blog",
        component: AdminBlog,
        exact: true,
      },
      {
        component: Error404,
      }, //manda página de error en caso de no cumplirse las direcciones
    ], //array de objetos
  },
  {
    path: "/",
    component: LayoutBasic,
    exact: false, //puede existir diferentes raices, "/blog" "/cont"
    routes: [
      {
        path: "/",
        component: Home,
        exact: true,
      },
      {
        path: "/contact",
        component: Contact,
        exact: true,
      },
      {
        path: "/courses",
        component: Courses,
        exact: true,
      },
      {
        path: "/blog",
        component: Blog,
        exact: true,
      },
      {
        path: "/blog/:url",
        component: Blog,
        exact: true,
      },
      {
        component: Error404,
      }, //manda página de error en caso de no cumplirse las direcciones
    ],
  }, //RUTAS PARA USUARIOS EN CASO DE TENER MÁS PÁGINAS AGREGARLAS AQUI
]; //array que contendrá la rutas de la pagina Admin y Usuarios normales
export default routes;
